import styled from "@emotion/styled";
import { Box, Theme } from "@mui/material";
import { Carousel } from "react-responsive-carousel";

export const Container = styled(Box)<{}>((props) => ({
    position: 'relative',
}));

export const StyledCarousel = styled(Carousel)((props) => ({
    '& > div': {
        maxHeight: '500px',
    }
}))

export const StyledBox = styled(Box)<{theme: Theme}>((props) => ({
    marginTop: props.theme.spacing(5),
    overflow: "auto",
    whiteSpace: "nowrap",
    paddingTop: props.theme.spacing(1),
}));

export const StyledBoxCalendar = styled(Box)<{theme: Theme}>((props) => ({
    marginTop: props.theme.spacing(5),
    overflow: "auto",
    whiteSpace: "nowrap",
    paddingTop: props.theme.spacing(1),
}));

export const StyledCalendar = styled.img((props) => ({
    maxWidth: "100%",
    objectFit: "cover",
    '&:hover':{
        transform: "scale(1.2)",
        transition: "transform 0.3s ease-in-out"
    }
}))